import React from 'react'
import { Gallery } from '../../component/gallery/Gallery'

export default function GalleryPage() {
  return (
    <>
      <Gallery />
    </>
  )
}
